import type { TRuleWithTheme } from '@ackee/fela';

export const link: TRuleWithTheme = ({ theme: { fonts } }) => ({
    ...fonts.heroNewMedium,
});
